var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pt-0"},[_c('BranchOffice',{attrs:{"company":_vm.company}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }